import tracking from 'dibs-tracking';

function trackSocialMediaShare(label) {
    tracking.trackEvent({
        action: 'product from PDP',
        label,
        category: 'share',
    });
}

export function trackPinterestClick(itemTitle) {
    tracking.trackSocial({
        name: 'pinterest',
        opt_target: itemTitle, // eslint-disable-line camelcase
        event: 'share',
    });
    trackSocialMediaShare('pinterest');
}

export function trackFacebookClick(itemTitle) {
    tracking.trackSocial({
        name: 'facebook',
        opt_target: itemTitle, // eslint-disable-line camelcase
        event: 'share intent',
    });
    trackSocialMediaShare('facebook');
}

export function trackEmailClick(itemId) {
    tracking.trackEvent({
        category: 'email a friend',
        action: 'email a friend initiated',
        label: `item|${itemId}`,
    });
}

function trackPrintClick(withOrWithout) {
    tracking.trackEvent({
        category: 'product',
        action: 'print item',
        label: `print ${withOrWithout} price from pdp`,
    });
}
export function trackPrintWithPriceClick() {
    trackPrintClick('with');
}

export function trackPrintNoPriceClick() {
    trackPrintClick('without');
}
